











































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import { Common } from "@/lib/Common/Guid";

class SetpApiKeyPO {
  appKey: string;
  appSecret: string;
  tenantId: number;
}

@Component
export default class SetApiKey extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: 1 }) tenantId: number;
  entity: SetpApiKeyPO = new SetpApiKeyPO();
  loading: boolean = false;

  async created() {}

  save() {
    (this.$refs.roleForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if (this.entity.appKey == null || this.entity.appSecret == null) {
          this.$Modal.info({
            title: this.L("Tips"),
            content: this.L("AppKeyIsNull"),
          });
          return;
        }
        this.loading = true;
        await this.$store
          .dispatch({
            type: "tenant/setAppKey",
            data: this.entity,
          })
          .then((val) => {
            this.loading = false;
            this.$Modal.info({
              title: this.L("Tips"),
              content: val,
            });
          })
          .catch((err) => {
            this.loading = false;
            this.$Modal.error({
              title: this.L("Tips"),
              content: err,
            });
          });
        (this.$refs.roleForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.roleForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    this.$set(this.entity, "appKey", Common.Guid.MakeNewStr().ToString());
    this.$set(this.entity, "appSecret", Common.Guid.MakeNewStr().ToString());
    if (!value) {
      this.$emit("input", value);
    }
  }
  roleRule = {
    appKey: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("ApiKey")),
        trigger: "blur",
      },
    ],
    appSecret: [
      {
        required: true,
        message: this.L("FieldIsRequired", undefined, this.L("AppSecret")),
        trigger: "blur",
      },
    ],
  };
  //租户id
  @Watch("tenantId")
  getitemId() {
    this.entity.tenantId = this.tenantId;
  }
}
